import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-location-dm.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-location-dm.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateLocationDMConstants } from "./create-location-dm.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import Query from "@arcgis/core/rest/support/Query";
import Polygon from "@arcgis/core/geometry/Polygon";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { AlertType } from "../../../../shared/models/alert";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
import { debounceTime } from "rxjs";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
import { CreateApplicationLocationEcConstants } from "../../ec/create-application-location-ec/create-application-location-ec.constants";
import { MapTools } from "../../../../map/shared/map.tools";
let CreateLocationDmComponent = class CreateLocationDmComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    applicationCreateService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    mapService;
    selectedApplicationService;
    requestStatusService;
    mapTools;
    changeDetectorRefs;
    searchApplicationsService;
    active = 0;
    propertiesForm;
    propertiesFormGroupName = CreateLocationDMConstants.PROPERTIES_FORM_GROUP_NAME;
    descriptionLabel1 = CreateLocationDMConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateLocationDMConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateLocationDMConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateLocationDMConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateLocationDMConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateLocationDMConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateLocationDMConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateLocationDMConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateLocationDMConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateLocationDMConstants.SG_CODE_CONTROL;
    addressControl = CreateLocationDMConstants.ADDRESS_CONTROL;
    ownerControl = CreateLocationDMConstants.OWNER_CONTROL;
    cadastralDescriptionControl = CreateLocationDMConstants.CADASTRAL_DESCRIPTION_CONTROL;
    rateNumberControl = CreateLocationDMConstants.RATE_NUMBER_CONTROL;
    existingUseControl = CreateLocationDMConstants.EXISTING_USE_CONTROL;
    worthyOfPreservationControl = CreateLocationDMConstants.WORTHY_OF_PRESERVATION_CONTROL;
    reasonControl = CreateLocationDMConstants.REASON_CONTROL;
    over60Control = CreateLocationDMConstants.OVER_60_CONTROL;
    amafaPermissionControl = CreateLocationDMConstants.AMAFA_PERMISSION_CONTROL;
    erfNoTextPlaceHolder = CreateLocationDMConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateLocationDMConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateLocationDMConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateLocationDMConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateLocationDMConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateLocationDMConstants.ADDRESS_TEXT_PLACEHOLDER;
    cadastralDescriptionTextPlaceHolder = CreateLocationDMConstants.CADASTRAL_DESCRIPTION_TEXT_PLACEHOLDER;
    rateNumberTextPlaceHolder = CreateLocationDMConstants.RATE_NUMBER_TEXT_PLACEHOLDER;
    existingUseTextPlaceHolder = CreateLocationDMConstants.EXISTING_USE_TEXT_PLACEHOLDER;
    worthyOfPreservationTextPlaceHolder = CreateLocationDMConstants.WORTHY_OF_PRESERVATION_TEXT_PLACEHOLDER;
    reasonTextPlaceHolder = CreateLocationDMConstants.REASON_TEXT_PLACEHOLDER;
    over60TextPlaceHolder = CreateLocationDMConstants.OVER_60_TEXT_PLACEHOLDER;
    amafaPermissionTextPlaceHolder = CreateLocationDMConstants.AMAFA_PERMISSION_TEXT_PLACEHOLDER;
    ownerLabel = CreateLocationDMConstants.OWNER_LABEL;
    removePropertyLabel = CreateLocationDMConstants.REMOVE_PROPERTY_LABEL;
    copyOwnerLabel = CreateLocationDMConstants.COPY_OWNER_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    yesNoOptions = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    dmApplication;
    yes = SharedConstants.YES_NO_ENUM.Yes;
    applicantGroups = [];
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    mapComponent;
    isMapLoaded = false;
    selectedApplicationLocationDmSubscription;
    selectedPropertySubscription;
    clearLayerGraphicsSubjectSubscription;
    getTrueCentroidSubscription;
    applicationCreateServiceSubscription;
    constructor(createApplicationService, applicationCreateService, aflaModuleStrategyService, recipientListService, appController, mapService, selectedApplicationService, requestStatusService, mapTools, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.createApplicationService = createApplicationService;
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.mapService = mapService;
        this.selectedApplicationService = selectedApplicationService;
        this.requestStatusService = requestStatusService;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.getMetadata();
        this.initForm();
        this.checkSave();
        this.subscribeToProperty();
        if (this.createApplicationService.propertyData) {
            // this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.yesNoOptions = [];
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
        this.subscribeToClearMapGraphics();
        this.subscribeToCheckFormValidity();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.applicantGroups = stepMeta.applicantGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields() {
        this.getProperties().controls.forEach(item => {
            const propertyControl = item;
            const erfNoControl = propertyControl.get(this.erfNoControl);
            const farmNoControl = propertyControl.get(this.farmNoControl);
            const subdivisionControl = propertyControl.get(this.subdivisionControl);
            if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
                erfNoControl.setValidators(Validators.required);
                farmNoControl.clearValidators();
                subdivisionControl.clearValidators();
                farmNoControl.setValue("");
                subdivisionControl.setValue("");
                farmNoControl.disable();
                subdivisionControl.disable();
                subdivisionControl.markAsUntouched();
                farmNoControl.markAsUntouched();
                this.subdivisionControlRequired = false;
                this.farmNoControlRequired = false;
                this.erfNoControlRequired = true;
            }
            else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") || (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
                farmNoControl.setValidators(Validators.required);
                subdivisionControl.setValidators(Validators.required);
                erfNoControl.clearValidators();
                erfNoControl.setValue("");
                erfNoControl.disable();
                erfNoControl.markAsUntouched();
                this.subdivisionControlRequired = true;
                this.farmNoControlRequired = true;
                this.erfNoControlRequired = false;
            }
            else {
                erfNoControl.setValidators(Validators.required);
                farmNoControl.setValidators(Validators.required);
                subdivisionControl.setValidators(Validators.required);
                erfNoControl.enable();
                farmNoControl.enable();
                subdivisionControl.enable();
                erfNoControl.markAsUntouched();
                subdivisionControl.markAsUntouched();
                farmNoControl.markAsUntouched();
                this.subdivisionControlRequired = true;
                this.farmNoControlRequired = true;
                this.erfNoControlRequired = true;
            }
            const sgCodeControl = propertyControl.get(this.sgCodeControl);
            if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
                sgCodeControl.disable();
            }
            else {
                sgCodeControl.enable();
            }
            erfNoControl.updateValueAndValidity();
            farmNoControl.updateValueAndValidity();
            subdivisionControl.updateValueAndValidity();
            this.changeDetectorRefs.detectChanges();
        });
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    selectYesOrNo(index) {
        if (this.getProperties().controls[index].get(this.over60Control).value === this.yes || this.getProperties().controls[index].get(this.worthyOfPreservationControl).value === this.yes) {
            this.getProperties().controls[index].get(this.amafaPermissionControl).addValidators([Validators.required]);
        }
        else {
            this.getProperties().controls[index].get(this.amafaPermissionControl).clearValidators();
            this.getProperties().controls[index].get(this.amafaPermissionControl).reset();
        }
    }
    onCopyOwnerToApplicant(propertyIndex) {
        const ownersControl = this.getProperties().controls[propertyIndex].get(this.ownerControl);
        const selectedOwners = ownersControl.value ? ownersControl.value.filter((x) => x.selected === true) : [];
        if (selectedOwners.length === 0) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.NO_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length > 1) {
            this.appController.showMessage(CreateApplicationLocationEcConstants.MULTIPLE_OWNERS_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        if (selectedOwners.length === 1) {
            const applicant = RecipientUtils.buildApplicantStringForUserSettings(selectedOwners[0], this.applicantGroups);
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(applicant);
            this.appController.showMessage("Owner data successfully copied", AlertType.Success);
        }
    }
    checkSave() {
        this.selectedApplicationLocationDmSubscription = this.selectedApplicationService.$selectedApplication.subscribe(app => {
            this.dmApplication = app;
            if (this.dmApplication)
                this.syncMapExistingGeometries();
            this.changeDetectorRefs.detectChanges();
        });
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        form.reset();
        this.propertiesForm = form;
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateLocationDMConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        // TODO: build a lookup map for mapping the propertyData layer to the data for Property
        if (!found) {
            const newProperty = new FormGroup({
                id: new FormControl(0),
                applicationId: new FormControl(0),
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno")),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum")),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno")),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                cadastralDescription: new FormControl(null, [Validators.required]),
                rateNumber: new FormControl(null, [Validators.required]),
                existingUse: new FormControl(null, [Validators.required]),
                worthyOfPreservation: new FormControl(null, [Validators.required]),
                reason: new FormControl(null, [Validators.required]),
                over60: new FormControl(null, [Validators.required]),
                amafaPermission: new FormControl(null),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)]),
                owners: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
                .subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    this.getPropertyOwners(sgCode, newProperty);
                }, error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(CreateLocationDMConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                id: 0,
                                name: item.attributes.Name,
                                surname: item.attributes.Surname,
                                telephone: item.attributes.Telephone,
                                email: item.attributes.Email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod,
                                postalAddress: item.attributes.PostalAddress,
                                designation: item.attributes.Designation,
                                organisation: item.attributes.Organisation,
                                clientVatNumber: item.attributes.ClientVatNumber,
                                streetAddress: item.attributes.StreetAddress,
                                homePhone: item.attributes.Homephone,
                                idNumber: item.attributes.IDNumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber,
                                representative: item.attributes.Representative,
                                fax: item.attributes.Fax,
                                cellphone: item.attributes.Cellphone,
                                streetSuburb: item.attributes.StreetSuburb,
                                streetCity: item.attributes.StreetCity,
                                streetProvince: item.attributes.StreetProvince,
                                streetCode: item.attributes.StreetCode,
                                postalSuburb: item.attributes.PostalSuburb,
                                postalCity: item.attributes.PostalCity,
                                postalProvince: item.attributes.PostalProvince,
                                postalCode: item.attributes.PostalCode,
                                postalCountry: item.attributes.PostalCountry,
                                streetCountry: item.attributes.StreetCountry,
                                professionalBody: item.attributes.ProfessionalBody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber,
                                groups: []
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(CreateLocationDMConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                this.handleAddProperty(newProperty);
                if (owners.length > 0) {
                    RecipientUtils.setRecipients(owners, true, ownersControl);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            this.handleAddProperty(newProperty);
        }
    }
    handleAddProperty(newProperty) {
        const propertyControl = this.getProperties();
        if (this.getProperties().controls.length > 0) {
            this.appController.showMessage(CreateLocationDMConstants.ONLY_ONE_PROPERTY_ALLOWED, AlertType.Warning);
        }
        else {
            propertyControl.push(newProperty);
            this.active = 0;
            this.updateRequiredFields();
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
        }
        this.requestStatusService.removeBusySpinner("GetPropertyDate");
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Demolition management graphics", true);
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(2000)).subscribe(property => {
            if (property !== null) {
                this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    syncMapExistingGeometries() {
        const pa = this.getProperties();
        while (pa.controls.length > 0) {
            pa.removeAt(0);
        }
        this.dmApplication.properties.forEach((prop) => {
            pa.push(this.singleFg(prop));
            this.updateRequiredFields();
        });
    }
    subscribeToClearMapGraphics() {
        this.clearLayerGraphicsSubjectSubscription = this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.mapComponent.removeGraphicsFromMap("Draw Tool Layer");
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    singleFg(prop) {
        const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
        const propertyFoemGroup = new FormGroup({
            id: new FormControl(prop.id),
            applicationId: new FormControl(prop.applicationId),
            erfNo: new FormControl(prop.erfNumber),
            subdivision: new FormControl(prop.subdivision),
            allotment: new FormControl(prop.allotment, [Validators.required]),
            farmNo: new FormControl(prop.farmNumber),
            sgCode: new FormControl(prop.sgCode, [Validators.required]),
            address: new FormControl(prop.address, [Validators.required]),
            cadastralDescription: new FormControl(prop.cadastralDescription, [Validators.required]),
            rateNumber: new FormControl(prop.rateNumber, [Validators.required]),
            existingUse: new FormControl(prop.existingUse, [Validators.required]),
            worthyOfPreservation: new FormControl(prop.worthyOfPreservation, [Validators.required]),
            reason: new FormControl(prop.reason, [Validators.required]),
            over60: new FormControl(prop.over60, [Validators.required]),
            amafaPermission: new FormControl(prop.amafaPermission),
            centroid: new FormControl(null),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl(null, [Validators.required]),
            geometry: new FormControl(geom)
        });
        const ownerControl = propertyFoemGroup.get("owners");
        if (this.dmApplication.properties && this.dmApplication.properties.length > 0)
            RecipientUtils.setRecipients(prop.owners, true, ownerControl);
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geom));
        this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
            .subscribe({
            next: (trueCentroidResponse) => {
                propertyFoemGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
            }, error: (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.handleServerErrorMessage(CreateLocationDMConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
        return propertyFoemGroup;
    }
    subscribeToCheckFormValidity() {
        this.applicationCreateServiceSubscription = this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.propertiesForm && formGroupName === this.propertiesFormGroupName) {
                    this.propertiesForm.markAllAsTouched();
                    this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientService },
        { type: AppControllerService },
        { type: MapService },
        { type: SelectedApplicationService },
        { type: RequestStatusService },
        { type: MapTools },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateLocationDmComponent = __decorate([
    Component({
        selector: "app-create-location-dm",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], CreateLocationDmComponent);
export { CreateLocationDmComponent };
